export default __webpack_public_path__ + "static/media/diagiai.dc745bc6.png";